import formatDate from '@utils/format-date'
import formatPaymentMethod from '@utils/format-payment-method'

const orderStatusTitleMap = {
  CANCEL: '已取消',
  PAID: '已付款',
  UNPAID: '未付款',
};

const orderColorMap = {
  CANCEL: 'gray-1',
  PAID: 'primary',
  UNPAID: 'danger',
};

const orderPriceColorMap = {
  CANCEL: 'gray-1',
  PAID: 'primary',
  UNPAID: 'danger',
};

const orderInfoMap = {
  0: '預約取消',
  1: '預約確認',
  2: '預約保留',
  3: '預約確認',
  4: '預約確認',
  5: '預約確認',
  6: '預約確認',
};

const orderInfoColorMap = {
  CANCEL: 'warn',
  PAID: 'text',
  UNPAID: 'danger',
};

const orderInfoJoinMap = {
  0: '已取消',
  1: '預約確認',
  2: '預約保留',
  3: '即將參加',
  4: '參加中',
  5: '未參加',
  6: '已完成',
};

const orderInfoJoinColorMap = {
  0: 'Danger',
  1: 'Text',
  2: 'Danger',
  3: 'Indigo',
  4: 'Success',
  5: 'Danger',
  6: 'Text',
};

export function formatOrder(orderItem = {}) {
  return {
    title: formatOrderStatusTitle(orderItem.status, orderItem.paymentStatus, orderItem.cancelDate),
    color: formatOrderColor(orderItem.status, orderItem.paymentStatus, orderItem.cancelDate),
    priceColor: formatOrderPriceColor(orderItem.status, orderItem.paymentStatus, orderItem.cancelDate),
    info: formatOrderInfo(orderItem.status),
    infoColor: formatOrderInfoColor(orderItem.status, orderItem.paymentStatus, orderItem.cancelDate),
    paidInfo: formatOrderPaidInfo(orderItem),
  }
}

export function formatOrderStatusTitle(status, paymentStatus,cancelDate) {
  return orderStatusTitleMap[formatStatusToPaymentStatus(status, paymentStatus, cancelDate)]
}

export function formatOrderColor(status, paymentStatus,cancelDate) {
  return orderColorMap[formatStatusToPaymentStatus(status, paymentStatus, cancelDate)]
}

export function formatOrderPriceColor(status, paymentStatus,cancelDate) {
  return orderPriceColorMap[formatStatusToPaymentStatus(status, paymentStatus, cancelDate)]
}

export function formatOrderInfo(status) {
  return orderInfoMap[status]
}

export function formatOrderInfoColor(status, paymentStatus,cancelDate) {
  return orderInfoColorMap[formatStatusToPaymentStatus(status, paymentStatus, cancelDate)]
}

export function formatOrderPaidInfo({
  status,
  paymentStatus,
  cancelDate,
  paidDate,
  paymentExpiredDate,
  paymentMethod,
  allowExpired = 1
} = {}) {
  if(paymentStatus) {
    const orderPaidInfoMap = {
      CANCEL: `於${formatDate(cancelDate, 'dateWeekDay')} 取消`,
      PAID: `${formatDate(paidDate, 'dateWeekDay') || ''} ${formatPaymentMethod(paymentMethod)}`,
      UNPAID: paymentExpiredDate ? `請於${formatDate(paymentExpiredDate, 'yyyy/MM/dd HH:mm')}前付款` : '請前往付款',
    };

    if(allowExpired && paymentStatus === 'UNPAID') {
      return '請盡快付款'
    } else if(paymentMethod === 'Prepaid' && paymentStatus === 'UNPAID') {
      return paymentExpiredDate ? `請於${formatDate(paymentExpiredDate, 'yyyy/MM/dd HH:mm')}前確認` : '請前往付款';
    } else {
      return orderPaidInfoMap[formatStatusToPaymentStatus(status, paymentStatus, cancelDate)];
    }
  }
}

export function formatStatusToPaymentStatus(status, paymentStatus, cancelDate) {
  if(status === 0 || !!cancelDate) {
    return 'CANCEL'
  } else if(!paymentStatus) {
    if(status === 2) {
      return 'UNPAID'
    } else {
      return 'PAID'
    }
  } else {
    return paymentStatus
  }
}

// 參加狀態
export function formatOrderJoin(orderItem = {}) {
  return {
    title: formatOrderJoinStatusTitle(orderItem.status, orderItem.paymentStatus),
    color: formatOrderJoinColor(orderItem.status, orderItem.paymentStatus),
  }
}
export function formatOrderJoinStatusTitle(status, containerPaymentStatus) {
  let orderStatus = status
  if(containerPaymentStatus) {
    orderStatus = 2
  }
  return orderInfoJoinMap[orderStatus]
}

export function formatOrderJoinColor(status, containerPaymentStatus) {
  let orderStatus = status
  if(containerPaymentStatus) {
    orderStatus = 2
  }
  return orderInfoJoinColorMap[orderStatus]
}
